import { useEffect, useState } from 'react';

/**
 * Delays a frequently changing value until it has been stable for `delay` ms.
 * This keeps search driven requests from being sent for every keystroke.
 */
export const useDebouncedValue = <T>(value: T, delay = 300): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setDebouncedValue(value), delay);
    return () => window.clearTimeout(timeoutId);
  }, [value, delay]);

  return debouncedValue;
};
